export const DASHBOARD_WIDGETS = [
  {
    id: "01",
    text: "Attachments, Links, and Notes",
    subChild: [
      /*  {
        id: "01-01",
        bgcolor: "plum",
        text: "Project Links",
        category: "Attachments, Links, and Notes",
        subChild: [*/
      {
        widgetId: 1,
        id: "01-01",
        size: 3,
        image: "project_team.png",
        text: "Links",
        category: "Attachments, Links, and Notes",
        appliesTo: "TMFF",
      } /*,
          {
            widgetId: 2,
            id: "01-01-02",
            size: 3,
            image: "project_team.png",
            text: "Links - Normal (3)",
            category: "Attachments, Links, and Notes",
          },,
      ,*/,
      //],
      //},
      {
        widgetId: 3,
        id: "01-03",
        size: 3,
        image: "project_team.png",
        text: "Attachments",
        category: "Attachments, Links, and Notes",
        appliesTo: "TMFF",
      },
      {
        widgetId: 4,
        id: "01-04",
        size: 3,
        image: "project_team.png",
        text: "Project Notes",
        category: "Attachments, Links, and Notes",
        appliesTo: "TMFF",
      },
    ],
    appliesTo: "TMFF",
  },
  {
    id: "02",
    text: "Metrics",
    subChild: [
      {
        id: "02-01",
        text: "Project Metrics",
        bgcolor: "limegreen",
        category: "Metrics",
        subChild: [
          {
            widgetId: 5,
            id: "02-01-01",
            size: 9,
            image: "metrics_row.png",
            text: "Project Metrics (Row)",
            category: "Metrics",
            appliesTo: "TM",
          },
          {
            widgetId: 6,
            id: "02-01-02",
            size: 4,
            image: "metrics_bar.png",
            text: "Project Metrics (Bar)",
            category: "Metrics",
            appliesTo: "TM",
          },
          {
            widgetId: 7,
            id: "02-01-03",
            size: 3,
            image: "metrics_row.png",
            text: "Project Metrics (Table)",
            category: "Metrics",
            appliesTo: "TM",
          },
        ],
        appliesTo: "TM",
      },
      {
        id: "02-02",
        text: "Project Health",
        category: "Metrics",
        subChild: [
          {
            widgetId: 8,
            id: "02-02-01",
            size: 3,
            image: "project_health_gauge.png",
            text: "Schedule Health",
            category: "Metrics",
            appliesTo: "TMFF",
          },
          {
            widgetId: 9,
            id: "02-02-02",
            size: 3,
            image: "project_health_gauge.png",
            text: "Budget Health",
            category: "Metrics",
            appliesTo: "TM",
          },
        ],
        appliesTo: "TMFF",
      },
    ],
    appliesTo: "TMFF",
  },
  {
    id: "03",
    text: "Resources",
    subChild: [
      {
        widgetId: 10,
        id: "03-01",
        size: 4,
        image: "project_team.png",
        text: "Project Team",
        category: "Resources",
        appliesTo: "TMFF",
      },
      /*{
        widgetId: 11,
        id: "03-02",
        size: 6,
        image: "project_team.png",
        text: "Project Team (w/Role)",
        category: "Resources",
      },
      {
        widgetId: 12,
        id: "03-03",
        size: 6,
        image: "project_team.png",
        text: "Project Team (w/Last View)",
        category: "Resources",
      },*/
    ],
    appliesTo: "TMFF",
  },
  {
    id: "04",
    text: "Tasks",
    subChild: [
      {
        widgetId: 13,
        id: "04-01",
        size: 6,
        image: "current_tasks.png",
        text: "Current/Upcoming Tasks",
        category: "Tasks",
        appliesTo: "TMFF",
      },
      /*{
        id: "04-02",
        size: 6,
        image: "current_tasks.png",
        text: "Individual Current/Upcoming Tasks",
        category: "Tasks",
      },*/
    ],
    appliesTo: "TMFF",
  },
  {
    id: "05",
    text: "RAID Items",
    subChild: [
      {
        widgetId: 14,
        id: "05-01",
        size: 4,
        image: "project_team.png",
        text: "Risks",
        category: "RAID Items",
        appliesTo: "TMFF",
      },
      {
        widgetId: 15,
        id: "05-02",
        size: 4,
        image: "project_team.png",
        text: "Actions",
        category: "RAID Items",
        appliesTo: "TMFF",
      },
      {
        widgetId: 16,
        id: "05-03",
        size: 4,
        image: "project_team.png",
        text: "Issues",
        category: "RAID Items",
        appliesTo: "TMFF",
      },
      {
        widgetId: 17,
        id: "05-04",
        size: 4,
        image: "project_team.png",
        text: "Decisions",
        category: "RAID Items",
        appliesTo: "TMFF",
      },
    ],
    appliesTo: "TMFF",
  },
];
